/**
 * See client/pages/cohorts/connectors/shopee.js
 */
export const shopeeSettlementsFieldsMapping = [
  {
    inputName: 'Order ID',
    outputName: 'orderId'
  },
  {
    outputName: 'recordType',
    parseFunction: function () {
      return 'settlementLine'
    }
  },
  {
    outputName: 'orderPlatform',
    parseFunction: function (record, context) {
      return context?.platform || undefined
    }
  },
  {
    outputName: 'orderCountry',
    parseFunction: function (record, context) {
      return context?.country || undefined
    }
  },
  {
    inputName: 'Username (Buyer)',
    outputName: 'buyerUsername'
    // parseFunction
  },
  {
    inputName: 'Order Creation Date',
    outputName: 'createdAt'
    // Shopee provides a YYYY-MM-DD string
  },
  {
    inputName: 'Payout Completed Date',
    outputName: 'settledAt'
    // Shopee provides a YYYY-MM-DD string
  },
  //
  // Revenue
  {
    inputName: 'Original product price',
    outputName: 'originalProductPrice'
  },
  {
    inputName: 'Your Seller product promotion',
    outputName: 'yourSellerProductPromotion'
  },
  {
    inputName: 'Refund Amount',
    outputName: 'refundAmount'
  },
  {
    outputName: 'revenueGross',
    computeFormula: 'originalProductPrice + yourSellerProductPromotion + refundAmount',
    computeFormulaDecimals: 2
  },
  {
    inputName: 'Total Released Amount (RM)',
    outputName: 'totalReleasedAmount'
  },
  {
    outputName: 'settlementAmount',
    computeFormula: 'totalReleasedAmount',
    computeFormulaDecimals: 2
  },
  //
  // Discounts
  {
    inputName: 'Product Discount Rebate from Shopee',
    outputName: 'productDiscountRebateFromShopee'
  },
  {
    inputName: 'Voucher',
    outputName: 'voucher'
  },
  {
    inputName: 'Seller Absorbed Coin Cashback',
    outputName: 'sellerAbsorbedCoinCashback'
  },
  {
    outputName: 'discount',
    computeFormula: 'productDiscountRebateFromShopee + voucher + sellerAbsorbedCoinCashback',
    computeFormulaDecimals: 2
  },
  {
    outputName: 'revenueNet',
    computeFormula: 'revenueGross + discount',
    computeFormulaDecimals: 2
  },
  //
  // Distribution
  {
    inputName: 'Shipping Fee Paid by Buyer (excl. SST)',
    outputName: 'shippingFeePaidByBuyer'
  },
  {
    inputName: 'Shipping Rebate From Shopee',
    outputName: 'shippingRebateFromShopee'
  },
  {
    inputName: 'Seller Paid Shipping Fee SST',
    outputName: 'sellerPaidShippingFeeSalesTax'
  },
  {
    inputName: 'Actual Shipping Fee',
    outputName: 'actualShippingFee'
  },
  {
    inputName: 'Reverse Shipping Fee',
    outputName: 'reverseShippingFee'
  },
  {
    inputName: 'Reverse Shipping Fee SST',
    outputName: 'reverseShippingFeeSalesTax'
  },
  {
    inputName: 'Free Returns Program Shipping Fee Waivers',
    outputName: 'feeReturnsProgramShippingFeeWaivers'
  },
  {
    outputName: 'shippingSubtotal',
    computeFormula: 'shippingFeePaidByBuyer + shippingRebateFromShopee + sellerPaidShippingFeeSalesTax + actualShippingFee + reverseShippingFee + reverseShippingFeeSalesTax + feeReturnsProgramShippingFeeWaivers',
    computeFormulaDecimals: 2
  },
  {
    outputName: 'onlineDistributionFees',
    computeFormula: 'shippingSubtotal',
    computeFormulaDecimals: 2
  },
  //
  // Marketing fees
  {
    inputName: 'AMS Commission Fee',
    outputName: 'AMSCommissionFee'
  },
  {
    outputName: 'onlineMarketingAds',
    computeFormula: 'AMSCommissionFee',
    computeFormulaDecimals: 2
  },
  //
  // Platform fees
  {
    inputName: 'Commission Fee (incl. SST)',
    outputName: 'commissionFeeInclSalesTax'
  },
  {
    inputName: 'Service Fee (Incl. SST)',
    outputName: 'serviceFeeInclSalesTax'
  },
  {
    inputName: 'Free Returns Fee (Incl.SST)',
    outputName: 'freeReturnsFeeInclSalesTax'
  },
  {
    inputName: 'Transaction Fee (Incl. SST)',
    outputName: 'transactionFeeInclSalesTax'
  },
  {
    outputName: 'onlinePlatformFees',
    computeFormula: 'commissionFeeInclSalesTax + serviceFeeInclSalesTax + freeReturnsFeeInclSalesTax + transactionFeeInclSalesTax',
    computeFormulaDecimals: 2
  },

  {
    outputName: 'feesAndCharges',
    computeFormula: 'AMSCommissionFee + commissionFeeInclSalesTax + serviceFeeInclSalesTax + freeReturnsFeeInclSalesTax + transactionFeeInclSalesTax',
    computeFormulaDecimals: 2
  },
  {
    outputName: 'computedSettlementAmount',
    computeFormula: 'revenueNet + onlineMarketingAds + onlinePlatformFees + onlineDistributionFees',
    computeFormulaDecimals: 2
  },
  {
    outputName: 'mismatchSettlement',
    computeFormula: 'computedSettlementAmount - settlementAmount',
    computeFormulaDecimals: 2
  }
]
